<template>
  <card class="card">
    <div class="card-container  margin-vertical-l">
      <img src="/images/high-five-hands-drawing.png">
      <div class="headline ri-bold-title margin-top-m">
        {{ challengeEndTitle }}
      </div>
      <div class="description ri-body margin-bottom-l margin-top-xxs">
        {{ challengeEndSubtitle }}
      </div>
      <riseup-button
        variant="primary"
        size="slim"
        title="בחזרה לתזרים"
        :action="() => emit('click')"
      />
    </div>
  </card>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import RiseupButton from '@riseupil/base-ui/src/components/RiseupButton/RiseupButton.vue';
import { useChallengeStore } from '../../stores/challenge';
import Segment from '../../Segment';

const emit = defineEmits<{(event: 'click'): void}>();
const challengeStore = useChallengeStore();
const { challenge, hasExceededChallengeGoal, amountLeftOver, participant } = storeToRefs(challengeStore);

const challengeEndTitle = computed(() => (hasExceededChallengeGoal.value
  ? `כל הכבוד ${participant?.value?.firstName}, \nסיימת את האתגר!`
  : `כל הכבוד ${participant?.value?.firstName}, האתגר נגמר והצלחת לעמוד ביעד!`));

const challengeEndSubtitle = computed(() => (hasExceededChallengeGoal.value
  ? 'הפעם נראה שלא עמדת ביעד, אבל מקווים שנהנת מהדרך.'
  : `ועוד נשארו לך ${amountLeftOver.value} ₪ לבזבוזים.`));
Segment.trackUserGot('_challenge_ended_page', { challengeId: challenge?.value?.challengeId });
</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';

.header-section {
  display: grid;
  grid-template-columns: 2.5fr 0.5fr;
  height: 198px;
  gap: 16px;
}

.card {
  background-color: $riseup_white;
  color: $riseup_black;

  .card-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .headline {
      white-space: pre-wrap;
      text-align: center;
    }

    .description {
      text-align: center;
    }
  }
}
</style>
